exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".video-container[data-v-b9569ffa]{position:relative;width:100%}.video-container .video[data-v-b9569ffa]{width:100%;border:1px solid #b4bccc}.video-container .del-button[data-v-b9569ffa]{position:absolute;bottom:10px;right:0}", ""]);

// exports
